import React from 'react';
import { Button, Modal, notification, Space, Spin } from 'antd';
import { useMutation, useQueryClient } from 'react-query';
import useModal, { IModalPayload } from '@hooks/use-modal';
import { deleteCarrier } from '@services/carrier';
import { handleAPIError } from '@services/base';
import { Trash } from 'lucide-react';

export const DeleteCarrierModal = () => {
  const [modal, setModal] =
    useModal<IModalPayload<{ carrierId: string }>>('delete-carrier');
  const queryClient = useQueryClient();

  const onClose = () => {
    setModal({ isOpen: false, payload: null });
  };

  const { isLoading: isSubmitting, mutate } = useMutation(
    () => deleteCarrier(modal?.payload?.carrierId as string),
    {
      onSuccess: async () => {
        onClose();
        await queryClient.invalidateQueries('carriers');
        notification.success({
          message: 'Success',
          description: 'Carrier deleted successfully',
        });
      },
      onError: handleAPIError,
    },
  );

  const submit = () => {
    mutate();
  };

  return (
    <Modal
      destroyOnClose
      centered
      width={720}
      onCancel={onClose}
      footer={null}
      title={
        <>
          <Trash size={14} />
          Delete Carrier
        </>
      }
      visible={modal?.isOpen || false}
    >
      <Spin spinning={isSubmitting}>
        <div
          style={{
            maxHeight: '280px',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <p>Are you sure you want to delete this carrier? </p>
        </div>
        <div className={'text-center'}>
          <Space align={'center'}>
            <Button onClick={onClose}>Cancel</Button>
            <Button onClick={submit} type="primary" icon={<Trash size={14} />}>
              Confirm
            </Button>
          </Space>
        </div>
      </Spin>
    </Modal>
  );
};
